import { Button, Layout, Space } from "antd";
import React from "react";

const { Footer } = Layout;

// Example for actionButtons
//   const actionButtons = [
//     {
//       id: 1,
//       buttonType: "primary",
//       buttonHTMLType: "submit"
//       buttonText: "Save",
//       handleButton: someFn(),
//       icon: <Icon />
//       iconPosition: "start"
//     },
//   ];

const FormActions = ({ actionButtons = [] }) => {
  return (
    <>
      {actionButtons ? (
        <Footer
          className="bg-color-white p-[20px] border-[1px] border-solid border-[#ebedf3] fixed bottom-0 right-0 flex justify-end w-[calc(100vw - 18rem)] z-[999]"
          style={{
            width: "calc(100vw - 18rem)",
          }}
        >
          <Space size="middle">
            {actionButtons?.map((button) => (
              <Button
                className="min-w-[100px]"
                size="large"
                type={button?.buttonType || "primary"}
                htmlType={button?.buttonHTMLType || false}
                icon={button?.icon || false}
                iconPosition={button?.iconPosition || false}
                onClick={button?.handleButton}
                disabled={button?.disabled || false}
                form={button?.form || false}
                danger={button?.isDanger ? true : false}
                color={button?.color || false}
                variant={button?.variant || false}
              >
                {button.buttonText}
              </Button>
            ))}
          </Space>
        </Footer>
      ) : null}
    </>
  );
};

export default FormActions;
